<div class="mc-spring-board">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    {{ title }}
    <span class="mc-fill-remaining-flex-space"></span>
    <button mat-icon-button color="primary" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-body mc-log-dialog-body">
    <span *ngIf="data?.message" class="mc-log-dialog-message">{{ data?.message }}</span>
    <code *ngIf="data?.code" class="mc-log-dialog-message mc-padding-xxx-small mc-border-radius-normal mc-bg-basic-muted">{{ data?.code }}</code>
  </div>

  <div class="mc-log-dialog-copy-message">
    <button mat-mini-fab color="primary" matTooltip="Copy" (click)="copyMessage()">
      <mat-icon fontSet="project-titan" fontIcon="icon-copy"></mat-icon>
    </button>
  </div>
</div>